<script setup lang="ts">
import { computed } from "vue";
import { responsiveDSVariables } from "../../utilities/helpers";
import type { ITextProps } from "./VText.types";

const props = withDefaults(defineProps<ITextProps>(), {
  tag: "span",
  color: "primary",
  font: "body-large-regular",
});

const rootVariables = computed(() => {
  return {
    ...responsiveDSVariables("--_f", props.font, "--pl-font-"),
    ...responsiveDSVariables("--_c", props.color, "--pl-text-"),
  };
});
</script>

<template>
  <component :is="props.tag" class="pl-text" :style="rootVariables">
    <slot />
  </component>
</template>

<style lang="postcss" scoped>
.pl-text {
  --_c: currentcolor;
  --_f: initial;
  --_f-s: var(--_f);
  --_f-m: var(--_f-s);
  --_f-ml: var(--_f-m);
  --_f-l: var(--_f-ml);
  --_f-xl: var(--_f-l);
  --pl-text-color: var(--_c);
  --pl-text-font: var(--_f);

  font: var(--pl-text-font);
  color: var(--pl-text-color);
  margin: 0;
  white-space: pre-line;
}

@media (--pl-viewport-from-s) {
  .pl-text {
    --pl-text-font: var(--_f-s);
  }
}

@media (--pl-viewport-from-m) {
  .pl-text {
    --pl-text-font: var(--_f-m);
  }
}

@media (--pl-viewport-from-ml) {
  .pl-text {
    --pl-text-font: var(--_f-ml);
  }
}

@media (--pl-viewport-from-l) {
  .pl-text {
    --pl-text-font: var(--_f-l);
  }
}

@media (--pl-viewport-from-xl) {
  .pl-text {
    --pl-text-font: var(--_f-xl);
  }
}
</style>
